// removed by extract-text-webpack-plugin
module.exports = {"loadingOverlay":"_-src-components-LoadingOverlay-index---loadingOverlay---Vr7bW","loaderWrapper":"_-src-components-LoadingOverlay-index---loaderWrapper---fURKi"};


//////////////////
// WEBPACK FOOTER
// ./src/components/LoadingOverlay/index.css
// module id = 650
// module chunks = 1